import config from 'devextreme/core/config';

const licenseKey = import.meta.env.VITE_DEVEXPRESS_LICENSE_KEY as string | undefined;

if (licenseKey) {
  config({ licenseKey });
}
